import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/App.css';
import './styles/About.css';
import './styles/CardSwap.css';
import './styles/Contact.css';
import './styles/Education.css';
import './styles/Experience.css';
import './styles/Hero.css';
import './styles/LightRays.css';
import './styles/Loader.css';
import './styles/Navigation.css';
import './styles/Particles.css';
import './styles/Projects.css';
import './styles/Silk.css';
import './styles/Skills.css';
import './styles/Squares.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
